const lang = {
  title: 'よくある質問',
  content: [
    {
      question: '『ZENGO』で、何ができますか？',
      answer: '写真報告書の作成・編集ができます。 <br> 『ZENGOカメラ』アプリと連携することで、撮影と同時に高品質なクラウド写真報告書が完成します。',
    },
    {
      question: '報告書に使用する写真はどこから登録ができますか？',
      answer: '『ZENGOカメラ』アプリから写真登録ができます。AppStoreより無料ダウンロードができます。',
      appstore: 'ZENGOカメラを無料ダウンロード▼'
    },
    {
      question: '推奨環境は何ですか？',
      answer: '<div> 【スマートフォン】 <br> <strong>iOS</strong> ：12.0以上<br> <strong>ブラウザ</strong>：Mobile Safari最新版 <br> <br> <strong>Android</strong>：5.0以上 <br> <strong>ブラウザ</strong>：Chrome最新版 <br> <br> 【ネットワーク】<br> wi-fi　光回線　※ネットワーク環境必須</div>',
    },
    {
      question: '複数人で使用する場合、アカウントは人数分必要ですか？',
      answer: '人数分のアカウントが必要になります。',
    },
    {
      question: 'オフラインでも使用できますか？',
      answer: 'オンライン環境が必須です。',
    },
    {
      question: 'ZENGOカメラ以外で撮影した写真で報告書作成できますか？',
      answer: '端末の標準カメラアプリやデジカメで撮影した写真もお使いいただけます。',
    },
    {
      question: '報告書のレイアウトは決まっていますか？',
      answer: '標準的なレイアウトのご用意があります。<br>フォームは今後追加や、カスタマイズ対応も行っていく予定です。',
    },
    {
      question: '有料アカウントを申し込むと何ができますか？',
      answer: '『ZENGO』の機能を無制限で利用できます。有料アカウントの申し込みをする前に、無料アカウントで『ZENGO』を体験することができます。',
    },
    {
      question: '有料アカウントの利用料金はいくらかかりますか？',
      answer: '１アカウント年間26,400円（税込）です。<br><br> ※1ヶ月あたり2,200円（税込）',
    },
    {
      question: '有料アカウント利用料金の支払い方法を教えてください。',
      answer: '有料アカウントお申込み後に、当社より年間利用料金26,400円（税込）の請求書を発行しますので、請求書受領後７営業日以内に当社指定銀行口座へお振込みください。 <br> <br> ※現在クレジットカード払いは準備中です。',
    },
    {
      question: 'アカウント登録したのにログイン（ZENGO連携）できません。',
      answer: 'アカウント作成画面でメールアドレスを入力し、送信した時点ではまだ仮登録状態です。<br>その場合は【仮登録のお知らせ】メールに記載のURLより本登録を完了させてから、再度ログインをお試しください。<br> <br>※仮登録メールの有効期限は1時間です。それ以上経過してしまった場合は、初めの仮登録から行ってください。'
    },
  ]
}
export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/faq.js